import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import Routes from "../../helpers/Routes";
import { useEffect, useState } from "react";
import KpiDashboardContainer from "../../components/KPIs/KpiDashboardContainer";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";

function Backoffice() {
  const navigate = useNavigate();
  const { availableModules } = useAvailableModulesContext();

  const [loading, setLoading] = useState(false);
  const [isActiveKpiModule, setIsActiveKpiModule] = useState<boolean>(false);


  const MainContent = useDynamicComponent("AssistanceIndex", { loading, setLoading });

  const onNewTaskClick = () => {
    navigate(Routes.backoffice.create);
  };

  const intl = useIntl();

  //modulos ativos
  useEffect(() => {
    if (availableModules.includes("IsActiveKpiModule")) {
      setIsActiveKpiModule(true);
    }
  }, [availableModules]);

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <PageTitle title={"Assistências"} allowGoBack={false} />

          {isActiveKpiModule && (
            <Row style={{ marginRight: "1rem" }}>
              <KpiDashboardContainer
                technicianFilter={''}
              />
            </Row>
          )}

        </div>

        <Row>
          <Col
            xl={2}
            lg={3}
            md={3}
            sm={12}
            xs={12}
            style={{ marginTop: "1em" }}
          >
            <ButtonComponent
              text={intl.formatMessage({ id: "Backoffice.Create" })}
              onClick={onNewTaskClick}
              disabled={loading}
            />
          </Col>
        </Row>
        <div className="pageBody">{MainContent}</div>
      </div>
    </Layout>
  );
}

export default Backoffice;
